{"id":"ProductDetail.Info.Price","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Price","options":"options:*"}]}}}